const galleryMixin = {
  data() {
    return {
      galleryTab: '',
      loadedTabs: {
        photos: false,
        '3d': false,
        video: false,
      },
      ...(window.vueDefaultState || {}),
    }
  },
  watch: {
    galleryTab() {
      this.loadedTabs[this.galleryTab] = true
    },
  },
  async mounted() {
    this.loadedTabs[this.galleryTab] = true
  },
}

export default galleryMixin
